import type { ChannelType, Permission } from "sdk";

// TODO: rename to PermissionDescription
export type Perm = {
	id: Permission;
	group?: string;
	overwrite_group?: string;
	types: (ChannelType | "Room" | "Server")[];
	moderator?: boolean;
};

export const permissions: Array<Perm> = [
	{
		id: "Admin",
		group: "dangerous",
		types: ["Room", "Server"],
		moderator: false,
	},
	{
		id: "IntegrationsManage",
		group: "room",
		overwrite_group: "general",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
			"Calendar",
			"Document",
			"Wiki",
		],
		moderator: true,
	},
	{
		id: "IntegrationsBridge",
		group: "members",
		overwrite_group: "members",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: true,
	},
	{
		id: "EmojiManage",
		group: "room",
		types: ["Room"],
		moderator: true,
	},
	{
		id: "EmojiUseExternal",
		group: "room",
		overwrite_group: "messages",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: false,
	},
	{
		id: "InviteCreate",
		group: "members",
		overwrite_group: "members",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
			"Calendar",
			"Document",
			"Wiki",
		],
		moderator: false,
	},
	{
		id: "MemberTimeout",
		group: "members",
		types: ["Room", "Server"],
		moderator: true,
	},
	{
		id: "InviteManage",
		group: "members",
		overwrite_group: "members",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
			"Calendar",
			"Document",
			"Wiki",
		],
		moderator: true,
	},
	{
		id: "MemberBan",
		group: "members",
		types: ["Room", "Server"],
		moderator: true,
	},
	{
		id: "MemberKick",
		group: "members",
		overwrite_group: "members",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: true,
	},
	{
		id: "MemberNickname",
		group: "members",
		types: ["Room"],
		moderator: false,
	},
	{
		id: "MemberNicknameManage",
		group: "members",
		types: ["Room"],
		moderator: true,
	},
	{
		id: "MessageCreate",
		group: "messages",
		overwrite_group: "messages",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: false,
	},
	{
		id: "MessageCreateThread",
		group: "messages",
		overwrite_group: "messages",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: false,
	},
	{
		id: "MessageAttachments",
		group: "messages",
		overwrite_group: "messages",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: false,
	},
	{
		id: "MessageDelete",
		group: "messages",
		overwrite_group: "messages",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: true,
	},
	{
		id: "MessageEmbeds",
		group: "messages",
		overwrite_group: "messages",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: false,
	},
	{
		id: "MessageMassMention",
		group: "messages",
		overwrite_group: "messages",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: false,
	},
	{
		id: "MessagePin",
		group: "messages",
		overwrite_group: "messages",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: true,
	},
	{
		id: "ReactionAdd",
		group: "messages",
		overwrite_group: "messages",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: false,
	},
	{
		id: "ReactionManage",
		group: "messages",
		overwrite_group: "messages",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: true,
	},
	{
		id: "RoleApply",
		group: "members",
		types: ["Room", "Server"],
		moderator: true,
	},
	{
		id: "RoleManage",
		group: "room",
		overwrite_group: "general",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
			"Calendar",
			"Document",
			"Wiki",
		],
		moderator: true,
	},
	{
		id: "RoomEdit",
		group: "room",
		types: ["Room", "Server"],
		moderator: true,
	},
	{
		id: "ThreadCreatePublic",
		group: "channels",
		overwrite_group: "threads",
		types: ["Room", "Text", "Forum", "Forum2", "Category"],
		moderator: false,
	},
	{
		id: "ThreadCreatePrivate",
		group: "channels",
		overwrite_group: "threads",
		types: ["Room", "Text", "Category"],
		moderator: false,
	},
	{
		id: "ThreadManage",
		group: "channels",
		overwrite_group: "threads",
		types: ["Room", "Text", "Forum", "Forum2", "Category"],
		moderator: true,
	},
	{
		id: "ThreadEdit",
		group: "channels",
		overwrite_group: "threads",
		types: ["Room", "Text", "Forum", "Forum2", "Category"],
		moderator: true,
	},
	{
		id: "ChannelEdit",
		group: "channels",
		overwrite_group: "general",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
			"Calendar",
			"Document",
			"Wiki",
		],
		moderator: true,
	},
	{
		id: "ChannelManage",
		group: "channels",
		types: ["Room"],
		moderator: true,
	},
	{
		id: "ChannelView",
		group: "channels",
		overwrite_group: "general",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
			"Calendar",
			"Document",
			"Wiki",
		],
		moderator: false,
	},
	{
		id: "AuditLogView",
		group: "room",
		types: ["Room"],
		moderator: true,
	},
	{
		id: "AuditLogView",
		group: "server",
		types: ["Server"],
		moderator: true,
	},
	{
		id: "AnalyticsView",
		group: "room",
		types: ["Room"],
		moderator: false,
	},
	{
		id: "AnalyticsView",
		group: "server",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "ServerMetrics",
		group: "server",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "ServerMaintenance",
		group: "server",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "ServerOversee",
		group: "server",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "CalendarEventCreate",
		group: "calendar",
		types: ["Calendar", "Category"],
		moderator: false,
	},
	{
		id: "CalendarEventRsvp",
		group: "calendar",
		types: ["Calendar", "Category"],
		moderator: false,
	},
	{
		id: "CalendarEventManage",
		group: "calendar",
		types: ["Calendar", "Category"],
		moderator: false,
	},
	{
		id: "VoiceMove",
		group: "voice",
		overwrite_group: "voice",
		types: ["Room", "Voice", "Broadcast", "Category"],
		moderator: true,
	},
	{
		id: "VoiceDeafen",
		group: "voice",
		overwrite_group: "voice",
		types: ["Room", "Voice", "Broadcast", "Category"],
		moderator: true,
	},
	{
		id: "VoiceMute",
		group: "voice",
		overwrite_group: "voice",
		types: ["Room", "Voice", "Broadcast", "Category"],
		moderator: true,
	},
	{
		id: "VoicePriority",
		group: "voice",
		overwrite_group: "voice",
		types: ["Room", "Voice", "Broadcast", "Category"],
		moderator: true,
	},
	{
		id: "VoiceSpeak",
		group: "voice",
		overwrite_group: "voice",
		types: ["Room", "Voice", "Broadcast", "Category"],
		moderator: false,
	},
	{
		id: "VoiceVideo",
		group: "voice",
		overwrite_group: "voice",
		types: ["Room", "Voice", "Broadcast", "Category"],
		moderator: false,
	},
	{
		id: "VoiceVad",
		group: "voice",
		overwrite_group: "voice",
		types: ["Room", "Voice", "Broadcast", "Category"],
		moderator: false,
	},
	{
		id: "VoiceRequest",
		group: "voice",
		overwrite_group: "voice",
		types: ["Room", "Voice", "Broadcast", "Category"],
		moderator: false,
	},
	{
		id: "VoiceBroadcast",
		group: "voice",
		overwrite_group: "voice",
		types: ["Room", "Voice", "Broadcast", "Category"],
		moderator: false,
	},
	{
		id: "ChannelSlowmodeBypass",
		group: "messages",
		overwrite_group: "messages",
		types: [
			"Room",
			"Text",
			"Forum",
			"Forum2",
			"Voice",
			"Broadcast",
			"Category",
		],
		moderator: false,
	},
	{
		id: "DocumentCreate",
		group: "documents",
		overwrite_group: "documents",
		types: ["Room", "Wiki", "Category"],
		moderator: false,
	},
	{
		id: "DocumentEdit",
		group: "documents",
		overwrite_group: "documents",
		types: ["Room", "Document", "Wiki", "Category"],
		moderator: false,
	},
	{
		id: "DocumentComment",
		group: "documents",
		overwrite_group: "documents",
		types: ["Room", "Document", "Wiki", "Category"],
		moderator: false,
	},
	{
		id: "ApplicationCreate",
		group: "application",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "ApplicationManage",
		group: "application",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "CallUpdate",
		group: "voice",
		types: ["Room"],
		moderator: false,
	},
	{
		id: "MessageMove",
		group: "messages",
		types: ["Room"],
		moderator: false,
	},
	{
		id: "MessageRemove",
		group: "messages",
		types: ["Room"],
		moderator: false,
	},
	{
		id: "RoomCreate",
		group: "room",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "RoomManage",
		group: "room",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "RoomJoin",
		group: "room",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "RoomJoinForce",
		group: "room",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "UserProfileSelf",
		group: "user",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "UserManageSelf",
		group: "user",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "UserManage",
		group: "user",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "DmCreate",
		group: "user",
		types: ["Server"],
		moderator: false,
	},
	{
		id: "FriendCreate",
		group: "user",
		types: ["Server"],
		moderator: false,
	},
];

export const permissionGroups = new Map();
for (const p of permissions) {
	const g = permissionGroups.get(p.group ?? "other");
	if (g) {
		g.push(p);
	} else {
		permissionGroups.set(p.group ?? "other", [p]);
	}
}
